import { useQuery } from "@tanstack/react-query";
import { useNavigate, useParams } from "react-router-dom";
import { api } from "../api/custom-api.ts";
import Loader from "../components/loader.tsx";
import { Box, HStack, Stack, Table } from "@chakra-ui/react";
import { CustomPagination } from "../components/ui/custom-pagination.tsx";
import { formatTimestampToDate } from "../utils/mappers/timestamp.mapper.ts";
import { FaPlus } from "react-icons/fa";
import { Button } from "../components/ui/button.tsx";
import { usePagination } from "../hooks";

export const WarehouseExistsPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const pageSize = 10;

  const {
    pageIndex: pageExitIndex,
    setPage,
    nextPage: onNextExitPage,
    previousPage: onPreviousExitPage,
    canPreviousPage: canPreviousExitPage,
  } = usePagination({
    pageType: "exits",
    id: id!,
    pageSize,
  });

  const { data: exits, isLoading: isLoadingExits } = useQuery(
    ["exits", id, pageExitIndex, pageSize],
    () =>
      api.codebookExit.getCodebookExitsByWarehouseId(
        id!,
        pageSize,
        pageExitIndex * pageSize,
      ),
    {
      keepPreviousData: false,
    },
  );

  // Calculate canNextPage based on data
  const canNextExitPage = exits
    ? pageExitIndex < Number(exits?.totalPages) - 1
    : false;

  if (isLoadingExits) {
    return <Loader />;
  }

  return (
    <Box
      w="100%"
      h="full"
      pt="5.25rem"
      p="1rem"
      bg="white"
      display="flex"
      flexDirection="column"
      alignItems="center"
    >
      <HStack
        w="full"
        justify="space-between"
        pt="5.25rem"
        mb="1rem"
        flexWrap="wrap"
      >
        <Box fontSize={["lg", "xl", "2xl"]} fontWeight="semibold" color="black">
          PREGLED IZLAZA MATERIJALA
        </Box>
        <Button
          size={"sm"}
          colorPalette={"red"}
          variant={"outline"}
          color={"#000000"}
          backgroundColor={"#ffffff"}
          borderColor={"#ffffff"}
          fontWeight={"600"}
          fontSize={"14px"}
          borderRadius={"0.5rem"}
          onClick={() => navigate(`create`)}
        >
          <FaPlus /> Dodaj izlaz
        </Button>
      </HStack>
      <Stack width="full" gap="5">
        <Box overflowX="auto">
          <Table.Root
            size="sm"
            stickyHeader
            interactive
            variant="outline"
            minWidth="800px"
          >
            <Table.Header bg="gray.200">
              <Table.Row>
                <Table.ColumnHeader
                  key={1}
                  textAlign="center"
                  className="text-black font-semibold"
                >
                  BROJ FAKTURE
                </Table.ColumnHeader>
                <Table.ColumnHeader
                  key={2}
                  textAlign="center"
                  className="text-black font-semibold"
                >
                  DATUM IZDAVANJA FAKTURE
                </Table.ColumnHeader>
                <Table.ColumnHeader
                  key={3}
                  textAlign="center"
                  className="text-black font-semibold"
                >
                  KOLICINA
                </Table.ColumnHeader>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {exits?.items?.map((item) => (
                <Table.Row
                  key={item.id}
                  className="hover:bg-gray-100 cursor-pointer"
                >
                  <Table.Cell className={"text-black"} textAlign={"center"}>
                    {item.documentNumber}
                  </Table.Cell>
                  <Table.Cell className={"text-black"} textAlign={"center"}>
                    {formatTimestampToDate(item.publicationDate)}
                  </Table.Cell>
                  <Table.Cell className={"text-black"} textAlign={"center"}>
                    {item.quantity}
                  </Table.Cell>
                </Table.Row>
              ))}
            </Table.Body>
          </Table.Root>

          <CustomPagination
            count={exits!.totalItems}
            pageSize={10}
            currentPage={pageExitIndex}
            onPageChange={setPage}
            onNextPage={onNextExitPage}
            onPreviousPage={onPreviousExitPage}
            canNextPage={canNextExitPage}
            canPreviousPage={canPreviousExitPage}
            siblingCount={1}
          />
        </Box>
      </Stack>
    </Box>
  );
};
